import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { configuration } from 'src/configuration';
import { SharedService } from '../service/shared.service';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent {

  @Output() closeModalBody: EventEmitter<void> = new EventEmitter<void>();
  @Input() showContactInfo = true;
  emirates = configuration.EMIRATES;

  submit = false;
  isSubmitted = false;
  signupForm: FormGroup;
  myFormSubmit = false;
  apiServices: any;

  constructor(private formBuilder: FormBuilder, public shared: SharedService,private router: Router) {
    this.signupForm = this.formBuilder.group({
      f_name: new FormControl('', [Validators.required]),
      // l_name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      p_num: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      check_box: new FormControl('', [Validators.required]),
      isSellerRegistration: new FormControl(false)  // Add this line for the isSellerRegistration control
    });
    this.shared.isWhiteMenu = false;
  }

  get formControls() {
    return this.signupForm.controls;
  }

  async onSubmit() {
    this.myFormSubmit = true;
    console.log(this.signupForm.value);
  
    // Check if the form control exists before accessing its value
    let isSellerControl = this.signupForm.get('isSellerRegistration');
    let useSellerAPI = isSellerControl ? isSellerControl.value === true : false;
  
    let apiEndpoint = useSellerAPI
      ? configuration.ENDPOINT.SELLER_REGISTRATION
      : configuration.ENDPOINT.BUYER_REGISTRATION;
  
    let res = await this.apiServices.POST_apiRequest(apiEndpoint, this.signupForm.value);
    console.log("res", res);
  
    if (res && !res.error) {
      this.isSubmitted = true;
      // Redirect to the appropriate page based on the condition
      if (useSellerAPI) {
        this.router.navigate(['/seller-page']);
      } else {
        this.router.navigate(['/buyer-page']);
      }
    } else {
      console.error("Error submitting the form:", res);
      // Handle errors or display a message to the user
    }
  }


  // ... rest of your component code

  // Add a method to emit the event when needed
  closeBody() {
    this.closeModalBody.emit();
  }
  
}
